export const fileSourceModel = {
  local: 1,
  tencentCOS: 2,
  aliCOS: 3,
};
